export const locale = {
  lang: 'zh2',
  data: {
    'NOTIFICACIONES': {
      'INFO': {
        'HOY': '今天',
        'TITUNOT': '通知事项',
        'NOTTTIP': '标记为已读'
      },
      'EDITOR_EMAILS': {
        'NUEVAMOD': '<b>-ALVPRRO-</b>公司已对其一个或多个通讯电子邮件进行了修改',
        'NUEVAMODODS': '项目经理已更改<b>-ALVPRRO-</b>公司的一封或多封通讯电子邮件'
      },
      'AUTORI-ENCUESTA': {
        'AUTORIZAR-ENCUESTA': '<b>-ALVPRRO-</b>公司已发送授权进行调查',
      },
    },
    'NOTIFICACION_PRODUCT':{
      'PRODUCTOS_ID':{
        '20':'认证',
        '40':'认证 3.0',
        '41':'测量 3.0',
        '42':'Pulsecheck 3.0',
        '43':'焦点区域',
        '56': 'AMCO',
        '57': '体面的工作',
        '58':'第一份工作',
        '63':'NOM-035 v3.0',
      },
      'TIPO_MENSAJE_MOSTRAR':{
        'languageNative':'您选择了主要语言',
        'sinAdicionales':'您没有选择其他语言',
        'languageAdittional':'您选择了其他语言',
        'conAdicionales':'您已取消选中没有附加语言的检查',
        'deleteLangNative':'您已删除母语',
        'completePasLang':'您已完成语言步骤',
        'completePasTemplate':'您已完成模板步骤',
        'completePasReacti': '您已完成试剂步骤',
        'completePasNps': '您已完成 nps 步骤',
        'completePasControl': '您已完成控制步骤',
        'completePasDemogra': '您已完成人口统计步骤',
        'completePasAbierta': '您已完成打开步骤',
        'completePasAdicio': '您已完成附加步骤',
        'completePas4all': '您已经完成了 forall 步骤',
        'completePasEncues': '您已完成调查步骤',
        'completePasColab': '您已完成合作者步骤',
        'completePasEnvi': '您已完成发送步骤',
        'completePasEstat': '您已完成调查状态步骤',
        'completePasProgra': '您已经完成了编程步骤',
        'DescompletePasLang': '您已完成语言步骤',
        'DescompletePasTemplate': '您已取消完成模板步骤',
        'DescompletePasReacti': '您尚未完成试剂步骤',
        'DescompletePasNps': '你已经完成了 nps 步骤',
        'DescompletePasControl': '您已取消完成控制步骤',
        'DescompletePasDemogra': '您尚未完成人口统计步骤',
        'DescompletePasAbierta': '您尚未完成打开的步骤',
        'DescompletePasAdicio': '您尚未完成附加步骤',
        'DescompletePas4all': '您尚未完成 forall 步骤',
        'DescompletePasEncues': '您尚未完成调查步骤',
        'DescompletePasColab': '您尚未完成协作者步骤',
        'DescompletePasEnvi': '您尚未完成发送步骤',
        'DescompletePasEstat': '您尚未完成调查状态步骤',
        'DescompletePasProgra': '您尚未完成编程步骤',
        'createSurvey': '调查已创建',
        'saveUserDemo': '您已将演示用户保存到调查中',
        'recreateSurvey': '调查已重新创建',
        'saveSeccionNps': 'nps 部分已保存到调查中',
        'saveSeccionReactivos': '试剂部分已保存到调查中',
        'saveSeccionControl': '控制部分已保存到调查中',
        'saveSeccionDemogra': '人口统计部分已保存到调查中',
        'saveSeccionAbier': '打开的部分已保存到调查中',
        'saveSeccionForall': 'Forall 部分已保存到调查中',
        'saveSeccionAdicio': '附加部分已保存到调查中',
        'subBaseColab': '贡献者库已上传',
        'downloadBaseColab': '贡献者库已下载',
        'deleteBaseColab': '贡献者库已被删除',
        'saveUsersSurvey': '调查合作者已被保存',
        'regisFechaLanza': '调查的启动日期已被记录',
        'regisFechaAviso1': '调查前通知 1 的日期已被记录',
        'regisFechaAviso2': '调查前的警告 2 的日期已被记录',
        'saveRecordatorioEncu': '已记录提醒',
        'enviarCorreos': '您已选择向您的合作者发送邮件',
        'noEnviarCorreos': '您已选择不向您的合作者发送邮件',
        'cambiarEstatusCorreo': '您已进行更改以修改邮件发送',
        'ActivaEstatEncu': '调查已激活',
        'DesacEstatEncu': '调查已停用',

        'activoSeccionNps':'已为调查激活 NPS 部分',
        'desActivoSeccionNps':'NPS 部分已为调查停用',
        'activoSeccionReactivos':'REACTIVE 部分已为调查激活',
        'desActivoSeccionReactivos':'REACTIVE 部分已为调查停用',
        'activoSeccionControl':'已为调查激活 CONTROL 部分',
        'desActivoSeccionControl':'该调查的控制部分已被停用',
        'activoSeccionDemograficos':'人口统计部分已为调查激活',
        'desActivoSeccionDemograficos':'人口统计部分已为调查停用',
        'activoSeccionAbiertas':'已为调查激活 OPEN 部分',
        'desActivoSeccionAbiertas':'ABIERTAS para la encuesta 部分已被停用',
        'activoSeccionForall':'FORALL 部分已为调查激活',
        'desActivoSeccionForall':'FORALL 部分已为调查停用',
        'activoSeccionAdicionales':'已为调查激活附加部分',
        'desActivoSeccionAdicionales':'附加部分已为调查停用',
        'deletePregTemNps':'问题已从 NPS 部分删除',
         'deletePregTemReacti':'该问题已从 REACTIVES 部分删除',
         'deletePregTemControl':'问题已从控制部分删除',
         'deletePregTemDemogra':'该问题已从 DEMOGRAPHICS 部分删除',
         'deletePregTemAbier':'问题已从 OPEN 部分删除',
         'deletePregTemAdici':'该问题已从附加部分删除',
         'savePregCatNps':'目录问题已保存到 NPS 部分',
         'savePregCatReacti':'目录问题已保存到 REAGENTS 部分',
         'savePregCatControl':'目录问题已保存到控制部分',
         'savePregCatDemogra':'目录问题已保存到 DEMOGRAPHICS 部分',
         'savePregCatAbier':'目录问题已保存到 OPEN 部分',
         'savePregCatAdici':'目录问题已保存到附加部分',
         'savePregNueNps':'新问题已保存到 NPS 部分',
         'savePregNueReacti':'新问题已保存到 REAGENTS 部分',
         'savePregNueControl':'新问题已保存到控制部分',
         'savePregNueDemogra':'新问题已保存在 DEMOGRAPHICS 部分',
         'savePregNueAbier':'新问题已保存到 OPEN 部分',
         'savePregNueAdici':'新问题已保存到附加部分',
         'editPregNps':'问题已在 NPS 部分编辑',
         'editPregReacti':'试剂部分的问题已被编辑',
         'editPregControl':'控制部分的问题已被编辑',
         'editPregDemogra':'DEMOGRAPHICS 部分的问题已被编辑',
         'editPregAbier':'OPEN 部分的问题已被编辑',
         'editPregAdici':'附加部分中的问题已被编辑',
         'LogOut':'您已注销',
         'reiniciarLang':'您已重新启动产品',
         'accionText':'',
         'updatCuesForall':'The questionnaire of the forall section has been updated.',
         'savePracticaForall':'练习 forall 已保存',
         'saveDescripForall':'已保存练习 forall 的描述。',

      },
      'BTN_MOSTRAR_HISTO':'显示历史',
      'ETI_PRODUC':'产品：',
      'TITLE_HISTO_PROD':'产品历史',
      'CARG_INFOR':'加载信息',
      'TITLE_FILTER':'过滤器：',
      'DELETE_FILTER':'删除过滤器',
      'FILTER_1':'日期：',
      'BUSCAR_FILTER':'搜索',
      'TH_TITTLE':'产品历史',
      'BTN_FILTER_HISTO':'过滤历史',
      'TD_USUARIO':'用户：',
      'TD_FECHA_PRODU':'产品日期：',
      'TD_TIPO_PRODU':'产品类型：',
      'TD_TIPO_USU_ADMI':'管理员用户',
      'WARNING_NO_DATOS':'无信息显示',

    }
  }
};
